import React from 'react';

import Editor from 'app/components/common/rich-text/editor';
import Viewer from 'app/components/common/rich-text/viewer';

const initialMd = `
# Rich Text Editing

It's finally here.

* lists
* and [links](https://www.youtube.com/watch?v=dQw4w9WgXcQ)
* and everything *nice* 😎
`;

class RteDebug extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      md: initialMd,
    };

    this.onChangeMd = this.onChangeMd.bind(this);
  }

  onChangeMd(getMd) {
    this.setState({md: getMd()});
  }

  render() {
    const {showMenu} = this.state;

    const things = [
      ['Input', <Editor onChange={this.onChangeMd} initialMd={this.state.md} />],
      ['Output Data', <pre style={{margin: 0, fontFamily: 'monospace'}}>{this.state.md}</pre>],
      ['Output Rendered', <Viewer md={this.state.md} />],
    ];

    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        {things.map(([label, thing], i) => {
          return (
            <div key={i} style={{border: '1px solid #7837C6', width: `33.33333%`, overflow: 'auto'}}>
              <div style={{borderBottom: '1px solid #7837C6', color: '#7837C6', padding: 12, fontWeight: 900, textTransform: 'uppercase'}}>{label}</div>
              <div style={{padding: 12}}>{thing}</div>
            </div>
          );
        })}
      </div>
    );
  }

}

export default RteDebug;
